import Api from '@/util/request'

//发送验证码
export const sendCode = (user: any) => {
    return Api.sendCode(user, 'POST')
}

//验证验证码
export const checkCode = (user: any) => {
    return Api.checkCode(user, 'POST')
}

//用户登录
export const loginUser = (user: any) => {
    return Api.loginUser(user, 'POST')
}

//退出登录
export const logout = () => {
    return Api.logout()
}

//查询用户
export const getUsers = (user: any) => {
    return Api.getUsers(user)
}

//获取用户
export const getUserById = (userId: number) => {
    return Api.getUserById({id: userId})
}

//保存用户
export const saveUser = (user: any) => {
    return Api.saveUser(user, 'POST')
}

//删除用户
export const removeUser = (userId: number) => {
    return Api.removeUser({id: userId})
}

//检查用户名
export const checkUserName = (userName: String) => {
    return Api.checkUserName({id: userName})
}

//个人信息
export const profile = (userId: number) => {
    return Api.profile({id: userId})
}

//修改密码
export const updatePwd = (user: any) => {
    return Api.updatePwd(user, 'POST')
}